import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Moma Design Studio
 * id B4972D96-B8A1-4964-8A58-FAEA2D0C5FF9
 * name escalator-box
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/escalator-box.svg
 * tags
 */
export const EscalatorBoxIcon = createSvgIcon(<><path d="M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M14.34 6H17.05C18.16 6 19.05 6.9 19.05 8C19.05 9.11 18.16 10 17.05 10H16L10 18H7.05C5.95 18 5.05 17.11 5.05 16C5.05 14.9 5.95 14 7.05 14H8.34L14.34 6Z" /></>, 'EscalatorBoxIcon');
export default EscalatorBoxIcon